<template>
  <span class="break-word">
    {{ t_text }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { IntervalType } from '@/shared/ui/SogScheduleSerie/types/IntervalType'
import type ScheduleSerieDefinition from '@/shared/ui/SogScheduleSerie/types/ScheduleSerieDefinition'
import { DayType } from '@/shared/ui/SogScheduleSerie/types/DayType'

interface Props {
  value?: ScheduleSerieDefinition
}

const props = withDefaults(defineProps<Props>(), { value: undefined })

const t_text = computed(() => {
  if (props.value) {
    switch (props.value.intervalType) {
      case IntervalType.None:
        return 'Keine Serie ausgewählt'

      case IntervalType.Minutely:
        return `alle ${props.value.interval} ${props.value.interval === 1 ? 'Minute' : 'Minuten'}`

      case IntervalType.Daily:
        return p_getDaily()

      default:
        return props.value.intervalType
    }
  }
  return ''
})

function p_getDaily() {
  switch (props.value?.dayType) {
    case DayType.All:
      if (props.value?.interval === 1) {
        return `Täglich um ${props.value.time?.slice(0, 5)} Uhr`
      }
      return `Täglich, alle ${props.value.interval} Tage um ${props.value.time?.slice(0, 5)} Uhr`

    case DayType.WorkingDayOnly:
      if (props.value?.interval === 1) {
        return `Täglich, jeden Arbeitstag um ${props.value.time?.slice(0, 5)} Uhr`
      }
      return `Täglich, alle ${props.value.interval} Arbeitstage um ${props.value.time?.slice(0, 5)} Uhr`

    case DayType.WorkingDay:
      if (props.value?.interval === 1) {
        return `Täglich, jeden Arbeitstag um ${props.value.time?.slice(0, 5)} Uhr`
      }
      return `Täglich, alle ${props.value.interval} Tage, Termin am Arbeitstag um ${props.value.time?.slice(0, 5)} Uhr`
  }
}
</script>

<style scoped>
.break-word {
  word-wrap: anywhere;
}
</style>
